const styles = {
  container: 'group cursor-pointer flex flex-col lg:flex-row gap-x-8',
  figure:
    '!aspect-video mb-4 lg:aspect-auto lg:w-[25rem] group-hover:border-red-500 duration-300 relative border-white',

  content: '',

  button:
    'text-black text-base underline group-hover:text-red-500 duration-300',

  head: '',
  body: 'pt-4',

  heading: 'text-3xl text-black font-bold',
  paragraph: 'text-black text-base pt-4',
  subtitle: 'text-black',
};

export default styles;
